import api from '@/api/axiosConfig.js';

const MAX_FILE_SIZE_BYTES = 6 * 1024 * 1024;
const ALLOWED_TYPES = new Set([
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
]);

function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error(`No se pudo leer el archivo ${file.name}.`));
    reader.readAsDataURL(file);
  });
}

export function validateChoferDocumentFile(file) {
  if (!file) return null;
  if (!ALLOWED_TYPES.has(file.type)) {
    return 'Solo se permiten archivos PDF, JPG, PNG o WEBP.';
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return 'El archivo supera el m\u00e1ximo permitido de 6 MB.';
  }
  return null;
}

export async function uploadChoferDocuments(choferId, files = []) {
  if (!choferId || !Array.isArray(files) || files.length === 0) {
    return null;
  }

  const normalized = [];
  for (const item of files) {
    if (!item?.file || !item?.key) continue;
    const validationError = validateChoferDocumentFile(item.file);
    if (validationError) {
      throw new Error(`${item.label || item.file.name}: ${validationError}`);
    }
    normalized.push({
      key: item.key,
      fileName: item.file.name,
      mimeType: item.file.type,
      dataUrl: await fileToDataUrl(item.file),
    });
  }

  if (normalized.length === 0) {
    return null;
  }

  const response = await api.post(`/api/choferes/${choferId}/documentos`, {
    files: normalized,
  });

  if (!response?.data?.ok) {
    throw new Error(response?.data?.error || response?.data?.message || 'No se pudo subir la documentaci\u00f3n.');
  }

  return response.data.data;
}

export default {
  uploadChoferDocuments,
  validateChoferDocumentFile,
};
